import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import FloatingInputField from "../../../molecules/formControls/inputField/FloatingInputField";
import DefaultButton from "../../../atoms/buttons/DefaultButton";
import ChangeProfileValidation from "./validation";
import { useContext } from "react";
import { AuthContext } from "../../../../context/authContext";
import { attrArrayToMap } from "../../../../helpers/utils";

const ChangeProfileForm = ({ onSubmit }) => {
  const { t } = useTranslation();
  const { attrInfo } = useContext(AuthContext);
  const attrMap = attrArrayToMap(attrInfo);

  const formik = useFormik({
    initialValues: {
      given_name: attrMap["given_name"] || "",
      family_name: attrMap["family_name"] || "",
    },
    validationSchema: ChangeProfileValidation(t),
    onSubmit,
  });

  return (
    <form
      onSubmit={formik.handleSubmit}
      autoComplete="off"
      className="flex flex-col gap-4"
    >
      <FloatingInputField
        id="given_name"
        name="given_name"
        label={t("signUp.name")}
        required={true}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values.given_name}
        formikTouched={formik.touched.given_name}
        error={formik.errors.given_name}
      />
      <FloatingInputField
        id="family_name"
        name="family_name"
        label={t("signUp.surname")}
        required={true}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values.family_name}
        formikTouched={formik.touched.family_name}
        error={formik.errors.family_name}
      />
      <DefaultButton
        type="submit"
        label={t("changeProfile.submit")}
        disabled={!(formik.isValid & formik.dirty) || formik.isSubmitting}
      />
    </form>
  );
};

export default ChangeProfileForm;
